import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import { imageryBgPlain } from '../../../../../assets/images'
import { MAGNET_SCORE_IMAGE, LEGEND_COLOR_MAP_V2 } from '../../../../../constants'

const RIGHT_CONTENT = '220px'

export const GraphContentLevel2 = styled(Box)(`
    display: flex;
    flex-wrap: wrap;
    background:#fff;

    & .contentText {
        padding:10px 0 0 240px;
        width: 100%;
        border:0;
        background: #fff;
    }
    & .contentText p {
        text-align:left;
        font-size: 12px;
        font-weight: 400;
    }
    & .list {
        margin-left:${RIGHT_CONTENT};
        background-image: url('${imageryBgPlain}');
        background-position: 0;
        background-repeat-x: no-repeat;
        background-size:100%; 
    }
    & .titleOnlyForProgression {
        width: 100%;
        border-bottom: 1px #F3F3F3 solid;
    }
    & .pptSubHeading {display:none}
`)

export const GraphRow = styled(Box)(`
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    min-height: 50px;
    border-top: 2px solid #F5F5F5;
`)

export const SliderWrap = styled(Box)(
  (props) => `
  height: 28px;
  border-bottom:1px #fff solid;
  display: flex;
  align-items: center;
  position: relative;
  & .sliderValue{
    left: ${props.percent}%;
    position: relative;
    background:  ${props?.color};
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
  & img {
    position: relative;
    left: ${props.percent}%;
    width: ${MAGNET_SCORE_IMAGE[props?.logoname || '']?.width || 'auto'}px;
    height: 15px;
    padding-left:3px;
  }
  ${props.percent > 50 && `
    .sliderValue{margin-left:-10px;}
  `}
  & .slider {
    -webkit-appearance: none;
    width: 100%;
    height: 12px;
    border-radius: 5px;
    background: transparent;
    outline: none;
    -webkit-transition: .2s;
    transition: opacity .2s;
    border-radius: 0;
  }
  
  & .slider:hover {
    background: ${props.disabled ? 'transparent' : '#ffffff50'};
  }
  
  & .slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: ${MAGNET_SCORE_IMAGE[props?.logoname || '']?.width || 80}px;
    height: 15px;
    object-fit: contain;
    border: 0;
    background-image: url(${props?.logo});
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    cursor: ${props.disabled ? 'default' : 'poiner'};
  }
  
  & .slider::-moz-range-thumb {
    appearance: none;
    width: ${MAGNET_SCORE_IMAGE[props?.logoname || '']?.width || 80}px;
    height: 15px;
    object-fit: contain;
    border: 0;
    background-image: url(${props?.logo});
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    cursor: pointer;
  }
`
)

export const GraphRowDetails = styled(Box)(`
    display: flex;
    width: 35px;
    justify-content: center;
    align-items: center;
    height: 30px;

    & > button {
        position: absolute;
        top: 0;
        right: 0;
        height:35px;
    }
`)
